import React, { useState } from "react";
import { AlertTriangle, Bell } from "lucide-react";
import api from "../../utils/api";
import { Button } from "../ui";
import { shortAgo } from "../../utils/liveChat";

// The navbar switch (PresenceSwitch) and this bar keep each other in step through this window event
export const PRESENCE_EVENT = "easychat:presence";

const notificationsSupported = typeof window !== "undefined" && "Notification" in window;

const AwayBar = ({ team, waitingCount, oldestWaitingMs, now, onPresenceChanged }) => {
  const [busy, setBusy] = useState(false);
  const [permission, setPermission] = useState(notificationsSupported ? Notification.permission : "denied");
  const me = team && team.agents ? team.agents.find((a) => a.is_me) : null;
  const away = me ? !me.online : false;

  const goOnline = async () => {
    setBusy(true);
    try {
      const res = await api.put("/live-chat/presence", { status: "online" });
      window.dispatchEvent(new CustomEvent(PRESENCE_EVENT, { detail: (res && res.status) || "online" }));
      onPresenceChanged && onPresenceChanged();
    } catch (e) {
      // the API client shows the error
    } finally {
      setBusy(false);
    }
  };

  const enableNotifications = async () => {
    try {
      setPermission(await Notification.requestPermission());
    } catch (e) {
      setPermission("denied");
    }
  };

  if (away && waitingCount > 0) {
    return (
      <div className="flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-2.5 text-amber-900">
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-600" />
        <p className="flex-1 text-[13px]">
          <span className="font-semibold">You're Away.</span>{" "}
          {waitingCount === 1 ? "1 visitor is" : `${waitingCount} visitors are`} waiting for an agent
          {oldestWaitingMs ? ` (longest ${shortAgo(oldestWaitingMs, now) === "now" ? "under a minute" : shortAgo(oldestWaitingMs, now)})` : ""}.
        </p>
        <Button variant="warning" size="sm" onClick={goOnline} disabled={busy}>
          {busy ? "Going online..." : "Go online"}
        </Button>
      </div>
    );
  }

  if (!away && notificationsSupported && permission === "default") {
    return (
      <div className="flex items-center gap-3 rounded-xl border border-zinc-200 bg-white px-4 py-2 text-zinc-700">
        <Bell className="h-4 w-4 shrink-0 text-zinc-500" />
        <p className="flex-1 text-[13px]">Get a desktop alert when a visitor is waiting for an agent.</p>
        <Button variant="outline" size="sm" onClick={enableNotifications}>Turn on alerts</Button>
      </div>
    );
  }
  return null;
};

export default AwayBar;
